import { render, staticRenderFns } from "./ReadOnlyProfileInfo.vue?vue&type=template&id=e50ce42a"
import script from "./ReadOnlyProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyProfileInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports